import { configureStore } from "@reduxjs/toolkit"
import thunk from "redux-thunk"
import rootReducer from "./reducers"

const middlewares = [thunk]

if (`${process.env.NODE_ENV}` === "development") {
    const { createLogger } = require("redux-logger")
    const logger = createLogger({
        diff: true,
        collapsed: true,
    })

    middlewares.push(logger)
}

const store = configureStore({
    middleware: middlewares,
    reducer: rootReducer,
    devTools: `${process.env.NODE_ENV}` === "development"
})

export default store
